module.exports = __webpack_public_path__ + "img/secondary_10x4.07398bbf.svg";